var map = {
	"./Communication-Equipment.jpg": 98764,
	"./National-Project-for-Village-1.jpg": 39890,
	"./National-Project-for-Village-2.jpg": 52300,
	"./National-Project-for-Village-3.jpg": 72675,
	"./National-Project-for-Village-4.jpeg": 13834,
	"./National-Project-for-Village-4.jpg": 43473,
	"./National-Project-for-Village-4.png": 94812,
	"./Power-Equipment-Installations-aion-mosa.jpg": 3259,
	"./Smart-Meters-Sky.png": 41985,
	"./Solar-Energy-Systems.jpg": 680,
	"./Surveillance-2-Sky.jpg": 54263,
	"./Surveillance-2-Sky.webp": 71027,
	"./Surveillance-Sky.jpg": 84717,
	"./china-company.jpg": 57191,
	"./old-National-Project-for-Village-2.jpg": 10964,
	"./old-Power-Equipment-Installations-aion-mosa.jpg": 14870,
	"./old-Smart-Meters-Sky.png": 80218,
	"./old-Surveillance-2-Sky.jpg": 92784,
	"./sig.jpg": 73081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55127;